import React from "react";
import { Button, Form, } from 'react-bootstrap';
import './StepOne.scss';
import ScrollAnimation from 'react-animate-on-scroll';
import { navigate } from "@reach/router"

const StepOne = (props) => {

  const handleBack = () => {
    // console.log ("test")

    navigate("/property-valuation/")
  }

  return (
    <div className="stepone">
      <div className="d-lg-block">
         {/* <ScrollAnimation animateIn='fadeIn' animateOnce={true}> */}
          {/* <div onClick={props.step === 0 ? props.handleBack : props.previous} onKeyPress={props.step === 0 ? props.handleBack : props.previous} className="back_icon"><i className="icon-back"></i> Back</div> */}

          <div onClick={handleBack} className="back_icon"><i className="icon-back"></i> Back</div>

        {/* </ScrollAnimation> */}
      </div>
      <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        <h2>Let’s start with your free home valuation.</h2>
      </ScrollAnimation>
      <div className="form-section">
            <div className="form-block-col">
                <ScrollAnimation animateIn='fadeIn' animateOnce={true} delay={300}>
                  <Form.Group>
                    <Form.Control className={props.nameError ? 'error-border' : ''} autoComplete="off" value={props.name} onChange={props.onChange} name="name" type="text" placeholder="Your First Name" />
                    {props.nameError &&
                    <div className="error">
                      Please Enter First name.
                    </div>
                    }
                  </Form.Group>
                  <Form.Group>
                    <Form.Control className={props.lastNameError ? 'error-border' : ''} autoComplete="off" value={props.lastName} onChange={props.onChange} name="lastName" type="text" placeholder="Your Last Name" />
                    {props.lastNameError &&
                    <div className="error">
                      Please Enter Last name.
                    </div>
                    }
                  </Form.Group>
                  <Form.Group>
                    <Form.Control className={props.emailError ? 'error-border' : props.valemailError ? 'error-border' : ''} autoComplete="off" value={props.email} onChange={props.onChange} name="email" type="email" placeholder="Email Address" />
                    {props.emailError &&
                    <div className="error">
                      Please Enter Email.
                    </div>
                    }
                    {props.valemailError && !props.emailError && 
                    <div className="error">
                      Please Enter Valid Email.
                    </div>
                    }
                  </Form.Group>
                  <Form.Group>
                    <Form.Control maxLength={13} className={props.phoneError ? 'error-border' : props.valphoneError ? 'error-border'  : ''} autoComplete="off" value={props.phone} onChange={props.onChange} name="telephone" type="text" placeholder="Telephone Number" />
                    {props.phoneError &&
                    <div className="error">
                      Please Enter Telephone.
                    </div>
                    }
                    {props.valphoneError && !props.phoneError && 
                    <div className="error">
                      Please Enter Valid Telephone.
                    </div>
                    }
                  </Form.Group>
                  <Form.Text>
                    <p className="pt-3">By submitting details, you agree to our <a href="/terms-and-conditions/">Terms & Conditions</a> and <a href="/privacy-policy/">Privacy Policy</a></p>
                  </Form.Text>
                  <Form.Group className="btn-bk-set">
                  <Button className="order-md-2" variant="primary" onClick={props.previous}>Back</Button>
                    <Button className="order-md-1" variant="primary" onClick={props.next}>Get Started</Button>
                  </Form.Group>
                </ScrollAnimation>
                <h2>How much is my house worth</h2>
                <p><b>Thinking of selling or letting your property?</b> Our professional <a href="/">estate agents in Manchester</a> provide a <b>free property valuation</b> to help you achieve the best possible outcome. Simply complete the form at the top of this page to receive a prompt and accurate answer to "how much is my house worth?" </p> <br></br>
                <p>Whether you're looking to <a href="/property-services/sell/">sell</a> or <a href="/property-services/rent/">rent</a>, our dedicated team offers expert guidance tailored to your needs. We gather detailed information and conduct a <b>thorough analysis of your property</b> and the local market to deliver an honest and precise valuation. Trust us to provide a <a href="/property-services/">comprehensive service</a> that ensures <b>you get the most from your property</b>. </p>
  </div>
    </div>
      </div>
  )
}

export default StepOne